import { CameraResetSvg } from "../../inlinesvgs/CameraResetSvg";
import { I18N } from "oc-I18N";

const buttonTitle = I18N("Kamera zurücksetzen");

export function CameraReset({
  resetFunction,
  className,
}: {
  resetFunction: () => void;
  className?: string;
}) {
  return (
    <button
      className={"camera-reset-button svg-button active " + className}
      title={buttonTitle}
      aria-label={buttonTitle}
      data-button-key="cameraReset"
      onClick={() => {
        resetFunction();
        APP.logUserAction({ action: "cameraReset" }, { stateChange: false });
      }}
    >
      <CameraResetSvg />
    </button>
  );
}
